<template>
  <v-content>
    <v-container>
      <v-card>
        <v-card-title>
          <h3>
            Mapped Pincode
          </h3>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            label="Search..."
            color="accent"
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :items="pincodes"
            :headers="headers"
            :search="search"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      pincodes: [],
      search: '',
    };
  },
  methods: {
    async getMappedPincodes() {
      const { pincodes } = this;
      const pincodesQuery = await this.firebase.firestore().collection('pincodes').get();
      pincodesQuery.forEach(async (item) => {
        pincodes.push({ pincode: item.id, ...await item.data() });
      });
    },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Pincode',
          value: 'pincode',
        },
        {
          text: 'Aso Id',
          value: 'asoId',
        },
        {
          text: 'Aso Name',
          value: 'asoName',
        },
      ];
    },
  },
  beforeMount() {
    this.getMappedPincodes();
  },
};
</script>
